// extracted by mini-css-extract-plugin
export var indeterminate = "_1l-6";
export var md = "_1l-5";
export var semantic = "_1l-7";
export var sm = "_1l-4";
export var text = "_1l-8";
export var toggleControl = "_1l-0";
export var toggleInput = "_1l-1";
export var toggleSwitch = "_1l-2";
export var xs = "_1l-3";